import Super from './class.js';
let serverList={
	get:{
	},
	post:{
		getShareItem:'/public/getShareItemInfo'
	},
};
export default new Super(serverList,'distr');